<template>
    <div class="pay-rv-page">
        <page-breadcrumb :items="pageBreadcrumbItems" :mobile="ebkMobile" />
        <!-- 筛选：桌面 -->
        <div
            v-show="!ebkMobile"
            class="row ai-c wrap filter-toolbar pay-rv-list-toolbar"
            data-ebk-guide="payrv-filter"
        >
            <span class="fc-sub">结算分类：</span>
            <el-select
                v-model="dataForm.is_up"
                class="hundred"
                size="small"
                placeholder="请选择"
                filterable
            >
                <el-option
                    v-for="item in statusData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3">发起时间：</span>
            <el-date-picker
                v-model="addTime"
                type="daterange"
                :unlink-panels="ebkMobile"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
            <span class="fc-sub ml-3">结算单号：</span>
            <el-input
                placeholder="请输入单据号"
                v-model="dataForm.ref"
                size="small"
                clearable
                class="hundreded"
            ></el-input>
            <el-button
                type="primary"
                icon="el-icon-search"
                class="ml-3 pl-3"
                @click="changeStatus"
                size="small"
                >查询</el-button
            >
            <el-button
                type="primary"
                icon="el-icon-plus"
                class="ml-3 pl-3"
                data-ebk-guide="payrv-create"
                @click="payRvDetailDiog"
                size="small"
                >发起结算</el-button
            >
            <el-button
                type="default"
                icon="el-icon-setting"
                class="ml-3 pl-3"
                size="small"
                data-ebk-guide="payrv-setting"
                @click="openSettlementSetting"
                >自动结算设置</el-button
            >
        </div>

        <!-- 筛选：移动端 — 折叠表单 + 横向快捷按钮 -->
        <div v-show="ebkMobile" class="pay-rv-mobile-filters" data-ebk-guide="payrv-filter">
            <el-collapse v-model="mobileFilterActive" accordion>
                <el-collapse-item title="筛选条件" name="filter">
                    <div class="pay-rv-m-fields">
                        <div class="pay-rv-m-field">
                            <span class="pay-rv-m-label">结算分类</span>
                            <el-select
                                v-model="dataForm.is_up"
                                class="pay-rv-m-control"
                                size="small"
                                placeholder="请选择"
                                filterable
                            >
                                <el-option
                                    v-for="item in statusData"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="pay-rv-m-field">
                            <span class="pay-rv-m-label">发起时间</span>
                            <el-date-picker
                                v-model="addTime"
                                class="pay-rv-m-control pay-rv-m-daterange"
                                type="daterange"
                                :unlink-panels="ebkMobile"
                                size="small"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始"
                                end-placeholder="结束"
                            >
                            </el-date-picker>
                        </div>
                        <div class="pay-rv-m-field">
                            <span class="pay-rv-m-label">结算单号</span>
                            <el-input
                                v-model="dataForm.ref"
                                class="pay-rv-m-control"
                                placeholder="单据号"
                                size="small"
                                clearable
                            ></el-input>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="pay-rv-m-actions">
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click="changeStatus"
                    >查询</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    plain
                    icon="el-icon-plus"
                    data-ebk-guide="payrv-create"
                    @click="payRvDetailDiog"
                    >发起结算</el-button
                >
                <el-button
                    size="small"
                    icon="el-icon-setting"
                    data-ebk-guide="payrv-setting"
                    @click="openSettlementSetting"
                    >设置</el-button
                >
            </div>
        </div>

        <div v-show="!ebkMobile" class="table-scroll-x">
        <el-table
            :data="tableData"
            stripe
            size="small"
            style="width: 100%"
            class="mt-3 pt-3"
            highlight-current-row
            data-ebk-guide="payrv-table"
        >
            <el-table-column prop="ref" label="结算单号">
                <template slot-scope="scope">
                    <span class="fc-m">{{scope.row.ding_ref_number}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="状态" width="120px">
                <template slot-scope="scope">
                    <span class="fc-e" v-if="scope.row.is_up == 0">等待审批</span>
                    <span class="fc-s" v-if="scope.row.is_up == 1">已经审批</span>
                    <span class="fc-wan" v-if="scope.row.is_up == 2">审批取消</span>
                    <span class="fc-m" v-if="scope.row.is_up == 3">部分审批</span>
                </template>
            </el-table-column>
            <el-table-column label="发票附件" min-width="130">
                <template slot-scope="scope">
                    <template v-if="settlementInvoiceUrls(scope.row).length">
                        <a
                            v-for="(u, i) in settlementInvoiceUrls(scope.row)"
                            :key="i"
                            :href="u"
                            target="_blank"
                            rel="noopener"
                            class="fc-m mr-2"
                        >{{
                            settlementInvoiceUrls(scope.row).length > 1
                                ? "附件" + (i + 1)
                                : "查看"
                        }}</a>
                    </template>
                    <span v-else class="fc-sub">—</span>
                </template>
            </el-table-column>
            <el-table-column
                label="驳回原因"
                min-width="140"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span
                        v-if="String(scope.row.is_up) === '2' && scope.row.oa_reject_remark"
                        class="fc-wan"
                    >{{ scope.row.oa_reject_remark }}</span>
                    <span v-else class="fc-sub">—</span>
                </template>
            </el-table-column>
            <el-table-column
                label="审批钱款"
                align="right"
                min-width="120"
            >
                <template slot-scope="scope">
                    <span>￥{{ auditRecordListOtherPrice(scope.row.other_price) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="转账状态" width="110" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="Number(scope.row.trans_status) === -1"
                        class="fc-s"
                        >转账成功</span
                    >
                    <span
                        v-else-if="Number(scope.row.trans_status) > 0"
                        class="fc-e"
                        >转账失败</span
                    >
                    <span v-else class="fc-sub">—</span>
                </template>
            </el-table-column>
            <el-table-column
                prop=""
                label="创建时间"
            >
                 <template slot-scope="scope">
                    <span>{{scope.row.date}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作">
                <template slot-scope="scope">
                    <span
                        class="fc-m fz-3 cur-p"
                        @click="getOrderDetail(scope.row)"
                        >详情</span
                    >
                </template>
            </el-table-column>
        </el-table>
        </div>

        <!-- 移动端：卡片列表（替代横向滚动表格） -->
        <div v-show="ebkMobile" class="pay-rv-card-list" data-ebk-guide="payrv-table">
            <div
                v-for="(row, idx) in tableData"
                :key="payRvCardRowKey(row, idx)"
                class="pay-rv-card"
                @click="getOrderDetail(row)"
            >
                <div class="pay-rv-card__head row jc-sb ai-c">
                    <div class="pay-rv-card__ref">{{ row.ding_ref_number }}</div>
                    <span
                        class="pay-rv-card__badge"
                        :class="'pay-rv-card__badge--' + payRvRowStatusTone(row)"
                        >{{ payRvRowStatusLabel(row) }}</span
                    >
                </div>
                <div class="pay-rv-card__row">
                    <span class="pay-rv-card__k">创建</span>
                    <span class="pay-rv-card__v">{{ row.date || "—" }}</span>
                </div>
                <div class="pay-rv-card__row pay-rv-card__row--split">
                    <span class="pay-rv-card__inline">
                        <span class="pay-rv-card__k">金额</span>
                        <span class="pay-rv-card__money"
                            >￥{{ auditRecordListOtherPrice(row.other_price) }}</span
                        >
                    </span>
                    <span class="pay-rv-card__inline pay-rv-card__inline--r">
                        <span class="pay-rv-card__k">转账</span>
                        <span
                            :class="{
                                'fc-s': Number(row.trans_status) === -1,
                                'fc-e': Number(row.trans_status) > 0,
                                'fc-sub':
                                    !(
                                        Number(row.trans_status) === -1 ||
                                        Number(row.trans_status) > 0
                                    ),
                            }"
                            >{{ payRvRowTransLabel(row) }}</span
                        >
                    </span>
                </div>
                <div
                    v-if="String(row.is_up) === '2' && row.oa_reject_remark"
                    class="pay-rv-card__reject"
                >
                    驳回：{{ row.oa_reject_remark }}
                </div>
                <div class="pay-rv-card__foot">
                    <span class="pay-rv-card__foot-invoice">
                        <span class="pay-rv-card__k">发票</span>
                        <span
                            v-if="!settlementInvoiceUrls(row).length"
                            class="fc-sub"
                            >—</span
                        >
                        <template v-else>
                            <a
                                v-for="(u, i) in settlementInvoiceUrls(row)"
                                :key="i"
                                :href="u"
                                target="_blank"
                                rel="noopener"
                                class="pay-rv-card__link"
                                @click.stop
                                >{{
                                    settlementInvoiceUrls(row).length > 1
                                        ? "附件" + (i + 1)
                                        : "查看"
                                }}</a
                            >
                        </template>
                    </span>
                    <span class="pay-rv-card__foot-link">详情</span>
                </div>
            </div>
            <div v-if="!tableData.length" class="pay-rv-card-empty">
                暂无结算数据
            </div>
        </div>

        <div class="mt-3 pt-3 pay-rv-pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="dataForm.page"
                :page-sizes="[ 10, 15, 20]"
                :page-size="dataForm.limit"
                :layout="
                    ebkMobile
                        ? 'total, prev, pager, next'
                        : 'total, sizes, prev, pager, next, jumper'
                "
                :small="ebkMobile"
                :pager-count="ebkMobile ? 5 : 7"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 新增结算申请弹框（大数据量：分页 + 表格内滚动） -->
        <el-dialog
            title="结算申请"
            :visible.sync="centerDialogVisible"
            :custom-class="
                'pay-rv-detail-dialog' +
                    (ebkMobile ? ' pay-rv-detail-dialog--mobile' : '')
            "
            width="92%"
            top="4vh"
            append-to-body
            :close-on-click-modal="false"
        >
            <div class="pay-rv-apply-body">
            <div
                v-loading="settlementInvoicePartiesLoading"
                class="mb-2 pay-rv-invoice-parties"
            >
                <div class="pay-rv-section-label">购销方信息</div>
                <template
                    v-if="settlementInvoiceParties && !settlementInvoicePartiesLoading"
                >
                    <el-alert
                        v-if="!settlementInvoiceParties.buyer"
                        type="warning"
                        :closable="false"
                        show-icon
                        :title="
                            '未查询到税号 ' +
                            (settlementInvoiceParties.default_buyer_tax_no ||
                                '') +
                            ' 对应的购买方发票档案'
                        "
                        description="请在 PSI「发票档案」(t_org_invoice) 中新增或维护该税号抬头，否则无法发起结算；审批通过后自动收票也依赖该档案。"
                        class="mb-2 pay-rv-party-alert"
                    />
                    <template v-if="ebkMobile">
                        <div class="pay-rv-apply-party-m">
                            <div class="pay-rv-ss-section">
                                购买方（默认税号
                                {{
                                    settlementInvoiceParties.default_buyer_tax_no ||
                                    "—"
                                }}）
                            </div>
                            <div class="pay-rv-ss-kv">
                                <div
                                    v-for="(it, i) in settlementBuyerKv"
                                    :key="'buy-' + i"
                                    class="pay-rv-ss-line"
                                >
                                    <span class="pay-rv-ss-line-k">{{ it.k }}</span>
                                    <span class="pay-rv-ss-line-v">{{ it.v }}</span>
                                </div>
                            </div>
                            <div class="pay-rv-ss-section">
                                销售方（开票方 · 本供应商）
                            </div>
                            <div class="pay-rv-ss-kv">
                                <div
                                    v-for="(it, i) in settlementSellerKv"
                                    :key="'sel-' + i"
                                    class="pay-rv-ss-line"
                                >
                                    <span class="pay-rv-ss-line-k">{{ it.k }}</span>
                                    <span class="pay-rv-ss-line-v">{{ it.v }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else class="pay-rv-party-grid">
                        <el-descriptions
                            :title="
                                '购买方（默认税号 ' +
                                (settlementInvoiceParties.default_buyer_tax_no ||
                                    '') +
                                '）'
                            "
                            :column="1"
                            size="small"
                            border
                        >
                            <template v-if="settlementInvoiceParties.buyer">
                                <el-descriptions-item label="名称">{{
                                    settlementInvoiceParties.buyer.invoice_title
                                }}</el-descriptions-item>
                                <el-descriptions-item label="税号">{{
                                    settlementInvoiceParties.buyer.invoice_tax_no
                                }}</el-descriptions-item>
                                <el-descriptions-item label="地址">{{
                                    settlementInvoiceParties.buyer
                                        .vat_company_address
                                }}</el-descriptions-item>
                                <el-descriptions-item label="电话">{{
                                    settlementInvoiceParties.buyer.vat_telphone
                                }}</el-descriptions-item>
                                <el-descriptions-item label="开户行">{{
                                    settlementInvoiceParties.buyer.vat_bank_name
                                }}</el-descriptions-item>
                                <el-descriptions-item label="账号">{{
                                    settlementInvoiceParties.buyer
                                        .vat_bank_account
                                }}</el-descriptions-item>
                            </template>
                            <el-descriptions-item v-else label="状态"
                                >未配置</el-descriptions-item
                            >
                        </el-descriptions>
                        <el-descriptions
                            title="销售方（开票方 · 本供应商）"
                            :column="1"
                            size="small"
                            border
                        >
                            <el-descriptions-item label="名称">{{
                                settlementInvoiceParties.seller.name
                            }}</el-descriptions-item>
                            <el-descriptions-item label="税号">{{
                                settlementInvoiceParties.seller.tax_number
                            }}</el-descriptions-item>
                            <el-descriptions-item label="地址">{{
                                settlementInvoiceParties.seller.address
                            }}</el-descriptions-item>
                            <el-descriptions-item label="电话">{{
                                settlementInvoiceParties.seller.tel01
                            }}</el-descriptions-item>
                            <el-descriptions-item label="开户行">{{
                                settlementInvoiceParties.seller.bank_name
                            }}</el-descriptions-item>
                            <el-descriptions-item label="账号">{{
                                settlementInvoiceParties.seller.bank_account
                            }}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                </template>
            </div>
            <div class="pay-rv-section-label">筛选待结算明细</div>
            <template v-if="ebkMobile">
                <div class="pay-rv-apply-filter-m">
                    <span class="pay-rv-apply-filter-m__lbl">离店日期</span>
                    <el-date-picker
                        v-model="dayaddTime"
                        type="daterange"
                        :unlink-panels="ebkMobile"
                        size="small"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="endDatePicker"
                        class="pay-rv-apply-daterange-m"
                    >
                    </el-date-picker>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        class="pay-rv-apply-query-m"
                        @click="payRvDetailList"
                        >查询</el-button
                    >
                    <p v-if="mTableData.length" class="pay-rv-apply-hint fc-sub">
                        共 <b>{{ mTableData.length }}</b> 条明细；合计为全部代数和（入库为正、退货为负）
                    </p>
                </div>
            </template>
            <template v-else>
                <div class="row ai-c wrap jc-sb pay-rv-dialog-toolbar">
                    <div class="row ai-c wrap">
                        <span class="fc-sub">离店日期：</span>
                        <el-date-picker
                            v-model="dayaddTime"
                            type="daterange"
                            :unlink-panels="ebkMobile"
                            size="small"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="endDatePicker"
                        >
                        </el-date-picker>
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            class="ml-2"
                            size="small"
                            @click="payRvDetailList"
                            >查询</el-button
                        >
                    </div>
                    <span v-if="mTableData.length" class="fc-sub"
                        >共 <b>{{ mTableData.length }}</b> 条，合计为全部明细代数和（入库为正、退货为负）</span
                    >
                </div>
            </template>
            <div v-show="!ebkMobile" class="table-scroll-x">
            <el-table
                :data="mTablePagedData"
                stripe
                size="small"
                border
                style="width: 100%"
                class="mt-2 pay-rv-detail-table"
                :max-height="payRvApplyTableMaxHeight"
                show-summary
                :summary-method="rvPayDetailApplySummaries"
            >
                <el-table-column prop="refType" label="业务类型" min-width="110"></el-table-column>
                <el-table-column prop="order_no" label="主订单号"></el-table-column>
                <el-table-column prop="refNumber" label="单号"></el-table-column>
                <el-table-column prop="bizDT" label="业务日期"></el-table-column>
                <el-table-column label="应结算金额">
                    <template slot-scope="scope">
                        <template v-if="rvPayDetailDueMoney(scope.row) !== ''">
                            ￥{{ rvPayDetailSignedDueDisplay(scope.row) }}
                        </template>
                        <template v-else>—</template>
                    </template>
                </el-table-column>
                <el-table-column label="已结算金额">
                    <template slot-scope="scope">
                        ￥{{ rvPayDetailSignedColDisplay(scope.row, 'actMoney') }}
                    </template>
                </el-table-column>
                <el-table-column label="未结算金额">
                    <template slot-scope="scope">
                        ￥{{ rvPayDetailSignedColDisplay(scope.row, 'balanceMoney') }}
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div v-show="ebkMobile" class="pay-rv-apply-lines-m">
                <div
                    v-for="(row, idx) in mTablePagedData"
                    :key="applyLineKey(row, idx)"
                    class="pay-rv-apply-line-card"
                >
                    <div class="pay-rv-apply-line-card__head">
                        <span class="pay-rv-apply-line-card__type">{{
                            row.refType || "—"
                        }}</span>
                        <span class="pay-rv-apply-line-card__date">{{
                            row.bizDT || "—"
                        }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__row">
                        <span class="k">主单</span>
                        <span class="v">{{ row.order_no || "—" }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__row">
                        <span class="k">单号</span>
                        <span class="v">{{ row.refNumber || "—" }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__money">
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">应</span>
                            <span class="mv">
                                <template v-if="rvPayDetailDueMoney(row) !== ''"
                                    >￥{{ rvPayDetailSignedDueDisplay(row) }}</template
                                >
                                <template v-else>—</template>
                            </span>
                        </span>
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">已</span>
                            <span class="mv">￥{{ rvPayDetailSignedColDisplay(row, 'actMoney') }}</span>
                        </span>
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">未</span>
                            <span class="mv pay-rv-apply-line-card__money-bal"
                                >￥{{ rvPayDetailSignedColDisplay(row, 'balanceMoney') }}</span
                            >
                        </span>
                    </div>
                </div>
                <div
                    v-if="mTableData.length"
                    class="pay-rv-apply-total-bar"
                >
                    <div class="pay-rv-apply-total-bar__t">合计（全部明细）</div>
                    <div class="pay-rv-apply-total-bar__g">
                        <span>应结算 {{ applyMobileGrandTotals.due }}</span>
                        <span>已结算 {{ applyMobileGrandTotals.act }}</span>
                        <span>未结算 {{ applyMobileGrandTotals.bal }}</span>
                    </div>
                </div>
                <div v-if="!mTableData.length" class="pay-rv-apply-lines-empty fc-sub">
                    暂无待结算明细，请调整离店日期后查询
                </div>
            </div>
            <el-pagination
                v-if="mTableData.length"
                class="pay-rv-dialog-pager mt-2"
                small
                background
                :current-page="applyDialogPage"
                :page-sizes="[30, 50, 100, 200]"
                :page-size="applyDialogPageSize"
                :layout="
                    ebkMobile
                        ? 'prev, pager, next'
                        : 'total, sizes, prev, pager, next, jumper'
                "
                :pager-count="ebkMobile ? 5 : 7"
                :total="mTableData.length"
                @current-change="onApplyDialogPageChange"
                @size-change="onApplyDialogSizeChange"
            />
            <div class="mt-2 pay-rv-invoice-foot" :class="{ 'pay-rv-invoice-foot--m': ebkMobile }">
                <div class="pay-rv-invoice-foot__title">请款与发票</div>
                <div class="fc-sub mb-1 pay-rv-money-line">
                    <span class="pay-rv-money-label">请款金额</span>
                    <span class="pay-rv-money-value"
                        >￥{{ settlementInvoiceActMoneyDisplay }}</span
                    >
                    <span class="pay-rv-money-hint"
                        >与系统结算汇总一致；金额为 0 时无需上传发票</span
                    >
                </div>
                <div v-if="settlementNeedsInvoiceFile" class="mb-2 pay-rv-invoice-type-row">
                    <div class="fc-sub mb-1">
                        <span class="pay-rv-required-star">*</span>发票类型
                    </div>
                    <el-select
                        v-model="settlementInvoiceIsVat"
                        size="small"
                        class="pay-rv-invoice-type-select"
                        placeholder="请选择发票类型"
                    >
                        <el-option
                            v-for="opt in settlementInvoiceTypeOptions"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                        />
                    </el-select>
                </div>
                <div v-if="settlementNeedsInvoiceFile" class="mb-2">
                    <div class="fc-sub mb-1">
                        <span class="pay-rv-required-star">*</span>发票编号（必填）
                    </div>
                    <el-input
                        v-model="settlementInvoiceNo"
                        size="small"
                        clearable
                        maxlength="80"
                        placeholder="请输入发票编号"
                    />
                </div>
                <div
                    class="pay-rv-upload-hint fc-sub mb-1"
                >
                    发票附件说明（金额非 0 时必填）：仅限 1 个文件，PDF / JPG / PNG，不超过 2MB；点击眼睛图标或文件名可预览。
                </div>
                <el-upload
                    action=""
                    :http-request="settlementInvoiceHttpRequest"
                    :auto-upload="false"
                    :file-list="settlementInvoiceFileList"
                    :on-change="handleSettlementInvoiceChange"
                    :disabled="!settlementNeedsInvoiceFile"
                    :limit="1"
                    accept=".pdf,.jpg,.jpeg,.png"
                >
                    <el-button
                        size="small"
                        type="default"
                        class="pay-rv-upload-pick"
                        :disabled="!settlementNeedsInvoiceFile"
                        >选择发票文件</el-button
                    >
                    <template slot="file" slot-scope="{ file }">
                        <div class="settlement-upload-file-row">
                            <i
                                class="el-icon-view settlement-upload-view-icon cur-p fc-m"
                                title="查看预览"
                                @click.stop="handleSettlementInvoicePreview(file)"
                            ></i>
                            <span
                                class="settlement-upload-file-name fc-m"
                                :title="file.name"
                                @click="handleSettlementInvoicePreview(file)"
                                >{{ file.name }}</span
                            >
                            <i
                                class="el-icon-close settlement-upload-remove-icon"
                                title="移除"
                                @click.stop="removeSettlementInvoiceFile(file)"
                            ></i>
                        </div>
                    </template>
                </el-upload>
            </div>
            </div>
            <span
                slot="footer"
                class="dialog-footer pay-rv-dialog-footer"
                :class="{ 'pay-rv-dialog-footer--m': ebkMobile }"
            >
                <el-button @click="payRvDetailDiogClose">取 消</el-button>
                <el-button type="primary" @click="someDingAddPayRvment" >申 请</el-button>
            </span>
        </el-dialog>

        <!-- 查询详情 -->
        <el-dialog
            title="结算申请详情"
            :visible.sync="noceDialogVisible"
            :custom-class="
                'pay-rv-detail-dialog' +
                    (ebkMobile ? ' pay-rv-detail-dialog--mobile' : '')
            "
            width="92%"
            top="4vh"
            append-to-body
            :close-on-click-modal="false"
        >
            <div class="pay-rv-apply-body">
            <template v-if="currentDetailRow">
                <el-alert
                    v-if="String(currentDetailRow.is_up) === '2' && currentDetailRow.oa_reject_remark"
                    type="error"
                    :closable="false"
                    show-icon
                    class="mb-2 pay-rv-party-alert"
                    :title="'审批驳回原因：' + currentDetailRow.oa_reject_remark"
                />
                <div
                    v-if="settlementInvoiceUrls(currentDetailRow).length"
                    class="mb-2 pay-rv-detail-invoice-row"
                >
                    <span class="fc-sub">本单上传的发票：</span>
                    <a
                        v-for="(u, i) in settlementInvoiceUrls(currentDetailRow)"
                        :key="i"
                        :href="u"
                        target="_blank"
                        rel="noopener"
                        class="fc-m ml-2"
                    >下载 {{ i + 1 }}</a>
                </div>
            </template>
            <template v-if="ebkMobile">
                <p v-if="nTableData.length" class="pay-rv-apply-hint fc-sub">
                    共 <b>{{ nTableData.length }}</b> 条明细；以下为卡片视图，合计见底部
                </p>
            </template>
            <div v-else-if="nTableData.length" class="pay-rv-dialog-toolbar fc-sub">
                共 <b>{{ nTableData.length }}</b> 条明细；表格可上下滚动，合计为全部数据代数和
            </div>
            <div v-show="!ebkMobile" class="table-scroll-x">
            <el-table
                :data="nTablePagedData"
                stripe
                size="small"
                border
                style="width: 100%"
                class="mt-2 pay-rv-detail-table"
                max-height="min(62vh, 560px)"
                show-summary
                :summary-method="rvPayDetailDetailSummaries"
            >
                <el-table-column prop="refType" label="业务类型" min-width="110"></el-table-column>
                <el-table-column prop="order_no" label="主订单号"></el-table-column>
                <el-table-column prop="refNumber" label="单号"></el-table-column>
                <el-table-column prop="bizDT" label="业务日期"></el-table-column>
                <el-table-column label="应结算金额">
                    <template slot-scope="scope">
                        <template v-if="rvPayDetailDueMoney(scope.row) !== ''">
                            ￥{{ rvPayDetailSignedDueDisplay(scope.row) }}
                        </template>
                        <template v-else>—</template>
                    </template>
                </el-table-column>
                <el-table-column label="已结算金额">
                    <template slot-scope="scope">
                        ￥{{ rvPayDetailSignedColDisplay(scope.row, 'actMoney') }}
                    </template>
                </el-table-column>
                <el-table-column label="未结算金额">
                    <template slot-scope="scope">
                        ￥{{ rvPayDetailSignedColDisplay(scope.row, 'balanceMoney') }}
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div v-show="ebkMobile" class="pay-rv-apply-lines-m">
                <div
                    v-for="(row, idx) in nTablePagedData"
                    :key="detailLineKey(row, idx)"
                    class="pay-rv-apply-line-card"
                >
                    <div class="pay-rv-apply-line-card__head">
                        <span class="pay-rv-apply-line-card__type">{{
                            row.refType || "—"
                        }}</span>
                        <span class="pay-rv-apply-line-card__date">{{
                            row.bizDT || "—"
                        }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__row">
                        <span class="k">主单</span>
                        <span class="v">{{ row.order_no || "—" }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__row">
                        <span class="k">单号</span>
                        <span class="v">{{ row.refNumber || "—" }}</span>
                    </div>
                    <div class="pay-rv-apply-line-card__money">
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">应</span>
                            <span class="mv">
                                <template v-if="rvPayDetailDueMoney(row) !== ''"
                                    >￥{{ rvPayDetailSignedDueDisplay(row) }}</template
                                >
                                <template v-else>—</template>
                            </span>
                        </span>
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">已</span>
                            <span class="mv">￥{{ rvPayDetailSignedColDisplay(row, 'actMoney') }}</span>
                        </span>
                        <span class="pay-rv-apply-line-card__money-i">
                            <span class="mk">未</span>
                            <span class="mv pay-rv-apply-line-card__money-bal"
                                >￥{{ rvPayDetailSignedColDisplay(row, 'balanceMoney') }}</span
                            >
                        </span>
                    </div>
                </div>
                <div
                    v-if="nTableData.length"
                    class="pay-rv-apply-total-bar"
                >
                    <div class="pay-rv-apply-total-bar__t">合计（全部明细）</div>
                    <div class="pay-rv-apply-total-bar__g">
                        <span>应结算 {{ detailMobileGrandTotals.due }}</span>
                        <span>已结算 {{ detailMobileGrandTotals.act }}</span>
                        <span>未结算 {{ detailMobileGrandTotals.bal }}</span>
                    </div>
                </div>
            </div>
            <el-pagination
                v-if="nTableData.length"
                class="pay-rv-dialog-pager mt-2"
                small
                background
                :current-page="detailDialogPage"
                :page-sizes="[30, 50, 100, 200]"
                :page-size="detailDialogPageSize"
                :layout="
                    ebkMobile
                        ? 'prev, pager, next'
                        : 'total, sizes, prev, pager, next, jumper'
                "
                :pager-count="ebkMobile ? 5 : 7"
                :total="nTableData.length"
                @current-change="onDetailDialogPageChange"
                @size-change="onDetailDialogSizeChange"
            />
            </div>
        </el-dialog>

        <!-- 结算设置：AUTO_SETTLEMENT_SPLIT 策略 + 收款账户 -->
        <el-dialog
            title="自动结算设置"
            :visible.sync="settlementSettingVisible"
            :width="ebkMobile ? '90%' : '560px'"
            :top="ebkMobile ? '6vh' : '15vh'"
            :custom-class="
                'pay-rv-settlement-setting-dialog' +
                    (ebkMobile ? ' pay-rv-ss--mobile' : '')
            "
            append-to-body
            @open="loadSettlementSetting"
        >
            <div v-loading="settlementSettingLoading" class="pay-rv-ss-wrap">
                <template v-if="settlementSetting && !settlementSettingLoading">
                    <!-- 移动端：键值行，避免 descriptions 表格留白与挤字 -->
                    <template v-if="ebkMobile">
                        <div class="pay-rv-ss-section">当前供应商</div>
                        <div class="pay-rv-ss-kv">
                            <div
                                v-for="(it, i) in settlementSupplierKv"
                                :key="'ss-sup-' + i"
                                class="pay-rv-ss-line"
                            >
                                <span class="pay-rv-ss-line-k">{{ it.k }}</span>
                                <span class="pay-rv-ss-line-v">{{ it.v }}</span>
                            </div>
                        </div>
                        <el-alert
                            v-if="settlementWarnTitle"
                            type="warning"
                            :closable="false"
                            show-icon
                            :title="settlementWarnTitle"
                            :description="settlementWarnDesc"
                            class="pay-rv-ss-alert"
                        />
                        <template v-if="settlementHasSplit">
                            <div class="pay-rv-ss-section">审批发起方式</div>
                            <p class="pay-rv-ss-hint">{{ settlementPolicyHint }}</p>
                            <div class="pay-rv-ss-kv">
                                <div
                                    v-for="(it, i) in settlementPolicyKv"
                                    :key="'ss-policy-' + i"
                                    class="pay-rv-ss-line"
                                >
                                    <span class="pay-rv-ss-line-k">{{ it.k }}</span>
                                    <span
                                        class="pay-rv-ss-line-v"
                                        :class="
                                            it.tone
                                                ? 'pay-rv-ss-line-v--' + it.tone
                                                : ''
                                        "
                                        >{{ it.v }}</span
                                    >
                                </div>
                            </div>
                        </template>
                        <template v-if="settlementSetting.hasAutoTrans">
                            <div class="pay-rv-ss-section">收款账户</div>
                            <div class="pay-rv-ss-kv">
                                <div
                                    v-for="(it, i) in settlementAccountKv"
                                    :key="'ss-acct-' + i"
                                    class="pay-rv-ss-line"
                                >
                                    <span class="pay-rv-ss-line-k">{{ it.k }}</span>
                                    <span class="pay-rv-ss-line-v">{{ it.v }}</span>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- 桌面端 -->
                    <template v-else>
                        <el-descriptions
                            title="当前供应商"
                            :column="1"
                            size="small"
                            border
                            class="mb-2"
                        >
                            <el-descriptions-item label="供应商名称">{{
                                settlementSetting.supplier &&
                                settlementSetting.supplier.name
                            }}</el-descriptions-item>
                            <el-descriptions-item label="渠道编码">{{
                                settlementSetting.supplier &&
                                settlementSetting.supplier.code
                            }}</el-descriptions-item>
                        </el-descriptions>
                        <el-alert
                            v-if="settlementWarnTitle"
                            type="warning"
                            :closable="false"
                            show-icon
                            :title="settlementWarnTitle"
                            :description="settlementWarnDesc"
                            class="mb-2"
                        />
                        <template v-if="settlementHasSplit">
                            <div class="pay-rv-ss-section mb-1">审批发起方式</div>
                            <p class="pay-rv-ss-hint mb-2">{{ settlementPolicyHint }}</p>
                            <el-descriptions
                                :column="1"
                                size="small"
                                border
                                class="mb-2"
                            >
                            <el-descriptions-item label="发起方式">
                                <span
                                    :class="
                                        settlementAutoCommitEnabled
                                            ? 'pay-rv-ss-val--ok'
                                            : 'pay-rv-ss-val--muted'
                                    "
                                    >{{ settlementAutoCommitText }}</span
                                >
                            </el-descriptions-item>
                            <el-descriptions-item label="审批合并">{{
                                settlementMergeCommitText
                            }}</el-descriptions-item>
                            <el-descriptions-item
                                v-if="settlementAutoCommitEnabled"
                                label="自动发起生效时间"
                                >{{ settlementAddTimeText }}</el-descriptions-item
                            >
                        </el-descriptions>
                        </template>
                        <el-descriptions
                            v-if="settlementSetting.hasAutoTrans"
                            title="收款账户"
                            :column="1"
                            size="small"
                            border
                        >
                            <el-descriptions-item label="收款账号">{{
                                settlementFieldText("shou_bank")
                            }}</el-descriptions-item>
                            <el-descriptions-item label="收款抬头">{{
                                settlementFieldText("name")
                            }}</el-descriptions-item>
                            <el-descriptions-item label="付款方式">{{
                                settlementFieldText("pay_type")
                            }}</el-descriptions-item>
                            <el-descriptions-item label="银行编码">{{
                                settlementFieldText("payee_acct_bank_code")
                            }}</el-descriptions-item>
                            <el-descriptions-item label="开户银行">{{
                                settlementFieldText("payee_acct_bank")
                            }}</el-descriptions-item>
                        </el-descriptions>
                    </template>
                </template>
            </div>
            <span slot="footer" class="dialog-footer pay-rv-ss-ft">
                <el-button
                    type="primary"
                    class="pay-rv-ss-close"
                    @click="settlementSettingVisible = false"
                    >关闭</el-button
                >
            </span>
        </el-dialog>

    </div>
</template>

<script>
import qs from "qs";
import { Loading } from "element-ui";
import {Message} from 'element-ui';
import mobileBreakpoint from "@/mixins/mobileBreakpoint";
import featureGuideMixin from "@/mixins/featureGuideMixin";
import { GUIDE_IDS } from "@/config/featureGuides";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
var options = {
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
};
export default {
    name: "payRvDetailList",
    components: { PageBreadcrumb },
    mixins: [mobileBreakpoint, featureGuideMixin],
    data() {
        return {
            ebkFeatureGuideId: GUIDE_IDS.payRvDetailList,
            mobileFilterActive: "",
            bodyStyle:{
                padding: '10px'
            },
            dataForm: {
                is_up: 3,
                ref: "",
                s_add_time: "",
                e_add_time: "",
            },
            statusData: [
                {
                    label: "全部",
                    value: 3,
                },
                {
                    label: "等待结算",
                    value: 0,
                },
                {
                    label: "已结算",
                    value: 1,
                },
                {
                    label: "结算取消",
                    value: 2,
                },
            ],
            tableData: [],
            total: 0,
            addTime: [],
            dayaddTime:[],
            detailVisible: false,
            centerDialogVisible: false,
            noceDialogVisible:false,
            mTableData: [],
            nTableData:[],
            currentDetailRow: null,
            applyDialogPage: 1,
            applyDialogPageSize: 50,
            detailDialogPage: 1,
            detailDialogPageSize: 50,
            payRvApplyTableMaxHeight: 480,
            payRvDetailTableMaxHeight: 520,
            settlementSettingVisible: false,
            settlementSettingLoading: false,
            settlementSetting: null,
            settlementInvoiceParties: null,
            settlementInvoicePartiesLoading: false,
            settlementInvoiceFileList: [],
            settlementInvoiceNo: "",
            settlementInvoiceIsVat: 1,
            settlementInvoiceTypeOptions: [
                { value: 1, label: "普通发票（纸质）" },
                { value: 4, label: "普通发票（电子）" },
                { value: 2, label: "增值税专用发票" },
                { value: 3, label: "客票行程单" },
            ],
            endDatePicker:{
                disabledDate: (time) => {
                  return time.getTime() > Date.now()
                },
            }

        };
    },
    computed: {
        pageBreadcrumbItems() {
            return [
                { label: "工作台", to: { path: "/hotel" } },
                { label: "结算列表" },
            ];
        },
        mTablePagedData() {
            const list = this.mTableData;
            const start =
                (this.applyDialogPage - 1) * this.applyDialogPageSize;
            return list.slice(start, start + this.applyDialogPageSize);
        },
        nTablePagedData() {
            const list = this.nTableData;
            const start =
                (this.detailDialogPage - 1) * this.detailDialogPageSize;
            return list.slice(start, start + this.detailDialogPageSize);
        },
        settlementAutoTrans() {
            return (
                (this.settlementSetting &&
                    this.settlementSetting.autoTrans) ||
                {}
            );
        },
        /** AUTO_SETTLEMENT_SPLIT 中当前渠道配置 */
        settlementSplit() {
            return (
                (this.settlementSetting &&
                    this.settlementSetting.settlement) ||
                {}
            );
        },
        settlementHasSplit() {
            return !!(
                this.settlementSetting &&
                this.settlementSetting.settlement
            );
        },
        settlementAutoCommitEnabled() {
            const v = this.settlementSplit["auto_commit"];
            return v === true || Number(v) === 1;
        },
        settlementPolicyHint() {
            return "说明：自动发起时间为离店当天下午 15:00。";
        },
        settlementMergeCommitText() {
            const v = this.settlementSplit["merge_commit"];
            if (v === null || v === undefined || v === "") {
                return "—";
            }
            if (v === true || Number(v) === 1) {
                return "多单合并一笔审批";
            }
            if (v === false || Number(v) === 0) {
                return "每单单独审批";
            }
            return String(v);
        },
        settlementAutoCommitText() {
            const v = this.settlementSplit["auto_commit"];
            if (v === null || v === undefined || v === "") {
                return "—";
            }
            if (v === true || Number(v) === 1) {
                return "开启自动";
            }
            if (v === false || Number(v) === 0) {
                return "关闭自动";
            }
            return String(v);
        },
        settlementWarnTitle() {
            if (this.settlementSetting && this.settlementSetting.hasAutoTrans) {
                return "";
            }
            if (this.settlementHasSplit) {
                return "尚未开通自动转账收款";
            }
            return "尚未开通配置自动结算策略";
        },
        settlementWarnDesc() {
            if (this.settlementSetting && this.settlementSetting.hasAutoTrans) {
                return "";
            }
            if (this.settlementHasSplit) {
                return "审批发起方式已配置，但收款账户或默认转账渠道未就绪。请发起结算前联系业务员完善银行账户与默认渠道。";
            }
            return "如需自动结算设置请联系业务员，在后台 AUTO_SETTLEMENT_SPLIT 中为本渠道配置结算策略。";
        },
        /** 与后端应付款请款汇总一致：单号以 PR 开头的明细按减法，其余按加法 */
        settlementInvoiceActMoney() {
            let act = 0;
            this.mTableData.forEach((row) => {
                const ref = String((row && row.refNumber) || "");
                const line = parseFloat(row.balanceMoney);
                if (isNaN(line)) {
                    return;
                }
                if (ref.substring(0, 2) === "PR") {
                    act -= line;
                } else {
                    act += line;
                }
            });
            return Math.round(act * 100) / 100;
        },
        settlementInvoiceActMoneyDisplay() {
            return this.rvPayDetailFormatMoney(this.settlementInvoiceActMoney);
        },
        settlementNeedsInvoiceFile() {
            return Math.round(Math.abs(this.settlementInvoiceActMoney) * 100) / 100 > 0;
        },
        settlementAddTimeText() {
            const v = this.settlementSplit["add_time"];
            if (v === null || v === undefined || v === "") {
                return "—";
            }
            const sec = parseInt(v, 10);
            if (isNaN(sec) || sec <= 0) {
                return String(v);
            }
            const d = new Date(sec * 1000);
            if (isNaN(d.getTime())) {
                return String(v);
            }
            const pad = (n) => (n < 10 ? "0" + n : "" + n);
            return (
                d.getFullYear() +
                "-" +
                pad(d.getMonth() + 1) +
                "-" +
                pad(d.getDate()) +
                " " +
                pad(d.getHours()) +
                ":" +
                pad(d.getMinutes()) +
                ":" +
                pad(d.getSeconds())
            );
        },
        settlementSupplierKv() {
            var st = this.settlementSetting;
            if (!st || !st.supplier) {
                return [];
            }
            var s = st.supplier;
            return [
                {
                    k: "供应商名称",
                    v:
                        s.name != null && String(s.name).trim() !== ""
                            ? String(s.name)
                            : "—",
                },
                {
                    k: "渠道编码",
                    v:
                        s.code != null && String(s.code).trim() !== ""
                            ? String(s.code)
                            : "—",
                },
            ];
        },
        settlementPolicyKv() {
            if (!this.settlementHasSplit) {
                return [];
            }
            var rows = [
                {
                    k: "发起方式",
                    v: this.settlementAutoCommitText,
                    tone: this.settlementAutoCommitEnabled ? "ok" : "muted",
                },
                {
                    k: "审批合并",
                    v: this.settlementMergeCommitText,
                },
            ];
            if (this.settlementAutoCommitEnabled) {
                rows.push({
                    k: "自动发起生效时间",
                    v: this.settlementAddTimeText,
                });
            }
            return rows;
        },
        settlementAccountKv() {
            var st = this.settlementSetting;
            if (!st || !st.hasAutoTrans) {
                return [];
            }
            return [
                {
                    k: "收款账号",
                    v: this.settlementFieldText("shou_bank"),
                },
                { k: "收款抬头", v: this.settlementFieldText("name") },
                { k: "付款方式", v: this.settlementFieldText("pay_type") },
                {
                    k: "银行编码",
                    v: this.settlementFieldText("payee_acct_bank_code"),
                },
                {
                    k: "开户银行",
                    v: this.settlementFieldText("payee_acct_bank"),
                },
            ];
        },
        settlementBuyerKv() {
            var p = this.settlementInvoiceParties;
            if (!p) {
                return [];
            }
            if (!p.buyer) {
                return [{ k: "状态", v: "未配置" }];
            }
            var b = p.buyer;
            return [
                { k: "名称", v: b.invoice_title || "—" },
                { k: "税号", v: b.invoice_tax_no || "—" },
                { k: "地址", v: b.vat_company_address || "—" },
                { k: "电话", v: b.vat_telphone || "—" },
                { k: "开户行", v: b.vat_bank_name || "—" },
                { k: "账号", v: b.vat_bank_account || "—" },
            ];
        },
        settlementSellerKv() {
            var p = this.settlementInvoiceParties;
            if (!p || !p.seller) {
                return [];
            }
            var s = p.seller;
            return [
                { k: "名称", v: s.name || "—" },
                { k: "税号", v: s.tax_number || "—" },
                { k: "地址", v: s.address || "—" },
                { k: "电话", v: s.tel01 || "—" },
                { k: "开户行", v: s.bank_name || "—" },
                { k: "账号", v: s.bank_account || "—" },
            ];
        },
        applyMobileGrandTotals() {
            var rows = this.mTableData || [];
            var due = 0;
            var act = 0;
            var bal = 0;
            rows.forEach((row) => {
                var raw = this.rvPayDetailDueMoney(row);
                var n = parseFloat(raw);
                if (!isNaN(n)) {
                    due += this.rvPayDetailSignedAmount(n, row);
                }
                var na = parseFloat(row.actMoney);
                if (!isNaN(na)) {
                    act += this.rvPayDetailSignedAmount(na, row);
                }
                var nb = parseFloat(row.balanceMoney);
                if (!isNaN(nb)) {
                    bal += this.rvPayDetailSignedAmount(nb, row);
                }
            });
            return {
                due: "￥" + this.rvPayDetailFormatMoney(due),
                act: "￥" + this.rvPayDetailFormatMoney(act),
                bal: "￥" + this.rvPayDetailFormatMoney(bal),
            };
        },
        detailMobileGrandTotals() {
            var rows = this.nTableData || [];
            var due = 0;
            var act = 0;
            var bal = 0;
            rows.forEach((row) => {
                var raw = this.rvPayDetailDueMoney(row);
                var n = parseFloat(raw);
                if (!isNaN(n)) {
                    due += this.rvPayDetailSignedAmount(n, row);
                }
                var na = parseFloat(row.actMoney);
                if (!isNaN(na)) {
                    act += this.rvPayDetailSignedAmount(na, row);
                }
                var nb = parseFloat(row.balanceMoney);
                if (!isNaN(nb)) {
                    bal += this.rvPayDetailSignedAmount(nb, row);
                }
            });
            return {
                due: "￥" + this.rvPayDetailFormatMoney(due),
                act: "￥" + this.rvPayDetailFormatMoney(act),
                bal: "￥" + this.rvPayDetailFormatMoney(bal),
            };
        },
    },
    created() {
        if (
            !Object.prototype.hasOwnProperty.call(this.$data, "currentDetailRow")
        ) {
            this.$set(this, "currentDetailRow", null);
        }
        this.getToday();
        this.changeStatus();
    },
    mounted() {
        this.syncPayRvDialogTableHeights();
        window.addEventListener("resize", this.syncPayRvDialogTableHeights);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.syncPayRvDialogTableHeights);
    },
    watch: {
        addTime(val) {
            if (val) {
                this.dataForm.s_add_time = val[0];
                this.dataForm.e_add_time = val[1];
            } else {
                this.dataForm.s_add_time = "";
                this.dataForm.e_add_time = "";
            }
        },
    },
    methods: {
        /** 应结算金额：采购入库等为 payMoney，采购退货出库等为 rvMoney */
        rvPayDetailDueMoney(row) {
            if (!row) {
                return "";
            }
            const p = row.payMoney;
            if (p != null && p !== "") {
                return p;
            }
            const r = row.rvMoney;
            if (r != null && r !== "") {
                return r;
            }
            return "";
        },
        rvPayDetailIsReturn(row) {
            return row && String(row.refType) === "采购退货出库";
        },
        /** 按业务类型取带符号数值：入库为正，退货出库为负（绝对值来自接口） */
        rvPayDetailSignedAmount(raw, row) {
            const n = parseFloat(raw);
            if (isNaN(n)) {
                return 0;
            }
            const mag = Math.abs(n);
            return this.rvPayDetailIsReturn(row) ? -mag : mag;
        },
        rvPayDetailFormatMoney(n) {
            const x = Number(n);
            if (isNaN(x)) {
                return "";
            }
            return x.toFixed(2);
        },
        /**
         * 发票 URL：优先 hy_ding_money.invoice_file（逗号/分号分隔），无则兼容从 remark 中「发票附件：」解析（旧数据）
         * @param {object|string} rowOrRemark
         */
        settlementInvoiceUrls(rowOrRemark) {
            let invoiceFile = "";
            let remark = "";
            if (rowOrRemark && typeof rowOrRemark === "object") {
                invoiceFile =
                    rowOrRemark.invoice_file != null
                        ? String(rowOrRemark.invoice_file)
                        : "";
                remark =
                    rowOrRemark.remark != null
                        ? String(rowOrRemark.remark)
                        : "";
            } else if (typeof rowOrRemark === "string") {
                remark = rowOrRemark;
            }
            const fromField = invoiceFile
                .split(/[,，;；]+/)
                .map((s) => s.trim())
                .filter(Boolean);
            if (fromField.length) {
                return fromField;
            }
            if (!remark) {
                return [];
            }
            const marker = "发票附件：";
            const urls = [];
            const lines = remark.split(/\r?\n/);
            lines.forEach((line) => {
                const idx = line.indexOf(marker);
                if (idx === -1) {
                    return;
                }
                const rest = line.slice(idx + marker.length).trim();
                if (!rest) {
                    return;
                }
                rest.split(/[；;]+/).forEach((p) => {
                    const u = p.trim();
                    if (u) {
                        urls.push(u);
                    }
                });
            });
            return urls;
        },
        /** 审批钱款：前端按正数展示 */
        auditRecordListOtherPrice(val) {
            if (val === null || val === undefined || val === "") {
                return "0.00";
            }
            const x = Math.abs(parseFloat(val));
            if (Number.isNaN(x)) {
                return "0.00";
            }
            return x.toFixed(2);
        },
        rvPayDetailSignedDueDisplay(row) {
            const raw = this.rvPayDetailDueMoney(row);
            if (raw === "" || raw == null) {
                return "";
            }
            const n = parseFloat(raw);
            if (isNaN(n)) {
                return raw;
            }
            return this.rvPayDetailFormatMoney(
                this.rvPayDetailSignedAmount(n, row)
            );
        },
        rvPayDetailSignedColDisplay(row, field) {
            const raw = row[field];
            if (raw == null || raw === "") {
                return this.rvPayDetailFormatMoney(0);
            }
            const n = parseFloat(raw);
            if (isNaN(n)) {
                return raw;
            }
            return this.rvPayDetailFormatMoney(
                this.rvPayDetailSignedAmount(n, row)
            );
        },
        rvPayDetailSummariesForRows(columns, rows) {
            const sums = [];
            const data = rows || [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计（全部）";
                    return;
                }
                const label = column.label;
                if (label === "应结算金额") {
                    let sum = 0;
                    data.forEach((row) => {
                        const raw = this.rvPayDetailDueMoney(row);
                        const n = parseFloat(raw);
                        if (!isNaN(n)) {
                            sum += this.rvPayDetailSignedAmount(n, row);
                        }
                    });
                    sums[index] = "￥" + this.rvPayDetailFormatMoney(sum);
                    return;
                }
                if (label === "已结算金额" || label === "未结算金额") {
                    const field =
                        label === "已结算金额" ? "actMoney" : "balanceMoney";
                    let sum = 0;
                    data.forEach((row) => {
                        const n = parseFloat(row[field]);
                        if (!isNaN(n)) {
                            sum += this.rvPayDetailSignedAmount(n, row);
                        }
                    });
                    sums[index] = "￥" + this.rvPayDetailFormatMoney(sum);
                    return;
                }
                sums[index] = "";
            });
            return sums;
        },
        rvPayDetailApplySummaries(param) {
            return this.rvPayDetailSummariesForRows(
                param.columns,
                this.mTableData
            );
        },
        rvPayDetailDetailSummaries(param) {
            return this.rvPayDetailSummariesForRows(
                param.columns,
                this.nTableData
            );
        },
        onApplyDialogPageChange(page) {
            this.applyDialogPage = page;
        },
        applyLineKey(row, idx) {
            var k =
                row &&
                (row.refNumber != null && row.refNumber !== ""
                    ? String(row.refNumber)
                    : row.order_no != null
                    ? String(row.order_no)
                    : "");
            return k !== "" ? "ap-" + k + "-" + idx : "ap-line-" + idx;
        },
        detailLineKey(row, idx) {
            var k =
                row &&
                (row.refNumber != null && row.refNumber !== ""
                    ? String(row.refNumber)
                    : row.order_no != null
                    ? String(row.order_no)
                    : "");
            return k !== "" ? "dt-" + k + "-" + idx : "dt-line-" + idx;
        },
        onApplyDialogSizeChange(size) {
            this.applyDialogPageSize = size;
            this.applyDialogPage = 1;
        },
        onDetailDialogPageChange(page) {
            this.detailDialogPage = page;
        },
        onDetailDialogSizeChange(size) {
            this.detailDialogPageSize = size;
            this.detailDialogPage = 1;
        },
        syncPayRvDialogTableHeights() {
            const h = window.innerHeight || 800;
            this.payRvApplyTableMaxHeight = Math.min(
                Math.round(h * 0.52 - 130),
                520
            );
            this.payRvDetailTableMaxHeight = Math.min(
                Math.round(h * 0.56 - 110),
                580
            );
        },
        // 获取今日日期
        getToday() {
            var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month =
                nowDate.getMonth() + 1 < 10
                    ? "0" + (nowDate.getMonth() + 1)
                    : nowDate.getMonth() + 1;
            var day =
                nowDate.getDate() < 10
                    ? "0" + nowDate.getDate()
                    : nowDate.getDate();
            this.addTime = [
                year + "-" + month + "-" + "01",
                year + "-" + month + "-" + day,
            ];
            this.dayaddTime = [
                year + "-" + month + "-" + "01",
                year + "-" + month + "-" + day,
            ];
            this.dataForm.s_add_time = this.addTime[0];
            this.dataForm.e_add_time = this.addTime[1];
        },
        // 获取订单列表
        billList() {
            if (!this.addTime) {
                Message.error("请选择时间范围");
            }
            Loading.service(options);

            let data = JSON.parse(JSON.stringify(this.dataForm))
            this.$axios.auditRecordList(qs.stringify(data)).then((res) => {
                Loading.service(options).close();
                const rows =
                    res && Array.isArray(res.data)
                        ? res.data
                        : res && Array.isArray(res)
                        ? res
                        : [];
                this.tableData = rows;
                this.total =
                    res && res.totalCount != null
                        ? parseInt(res.totalCount, 10) || 0
                        : 0;
            })
            .catch((err) => {
                Loading.service(options).close();
            });
        },
        // 酒店列表更改条数重新请求接口数据
        handleSizeChange(e) {
            this.dataForm.page = 1;
            this.dataForm.start = (this.dataForm.page)*e;
            this.dataForm.limit = e;
            this.billList();
        },
        // 修改页数
        handleCurrentChange(e) {
            this.dataForm.page = e;
            this.dataForm.start = (e - 1)*this.dataForm.limit;
            this.billList();
        },
        changeStatus() {
            this.dataForm.page = 1;
            this.dataForm.start = 0;
            this.dataForm.limit = 10;
            this.billList();
        },
        openSettlementSetting() {
            this.settlementSettingVisible = true;
        },
        loadSettlementSetting() {
            this.settlementSettingLoading = true;
            this.settlementSetting = null;
            this.$axios
                .supplierAutoTransSetting(qs.stringify({}))
                .then((res) => {
                    this.settlementSetting = res || null;
                })
                .catch(() => {
                    this.settlementSetting = null;
                })
                .then(() => {
                    this.settlementSettingLoading = false;
                });
        },
        settlementFieldText(key) {
            const at = this.settlementAutoTrans;
            if (!at || !(key in at)) {
                return "—";
            }
            const v = at[key];
            if (v === null || v === undefined || v === "") {
                return "—";
            }
            return String(v);
        },
        // 移动端卡片列表
        payRvCardRowKey(row, idx) {
            var id = row && (row.ding_ref_number || row.ref || row.id);
            if (id != null && id !== "") {
                return String(id);
            }
            return "pay-rv-row-" + idx;
        },
        payRvRowStatusLabel(row) {
            if (!row) {
                return "—";
            }
            var v = row.is_up;
            if (v == 0) {
                return "等待审批";
            }
            if (v == 1) {
                return "已经审批";
            }
            if (v == 2) {
                return "审批取消";
            }
            if (v == 3) {
                return "部分审批";
            }
            return "—";
        },
        /** warn | ok | danger | info */
        payRvRowStatusTone(row) {
            if (!row) {
                return "info";
            }
            var v = row.is_up;
            if (v == 0) {
                return "warn";
            }
            if (v == 1) {
                return "ok";
            }
            if (v == 2) {
                return "danger";
            }
            if (v == 3) {
                return "info";
            }
            return "info";
        },
        payRvRowTransLabel(row) {
            if (!row) {
                return "—";
            }
            if (Number(row.trans_status) === -1) {
                return "转账成功";
            }
            if (Number(row.trans_status) > 0) {
                return "转账失败";
            }
            return "—";
        },
        // 查看订单详情
        getOrderDetail(e) {
            Loading.service(options);
            this.nTableData = [];
            this.currentDetailRow = e || null;
            let data = {
                dingRefNumber: e.ding_ref_number ,
            };
            this.noceDialogVisible = true;
            this.$axios.rvPayDetailList(qs.stringify(data)).then((res) => {
                Loading.service(options).close();
                this.detailDialogPage = 1;
                if (res.dataList.length) {
                    this.nTableData = res.dataList;
                } else {
                    this.nTableData = [];
                }
            })
            .catch((err) => {
                Loading.service(options).close();
            });

        },
        payRvDetailDiog(){
            this.applyDialogPage = 1;
            this.settlementInvoiceFileList = [];
            this.settlementInvoiceNo = "";
            this.settlementInvoiceIsVat = 1;
            this.settlementInvoiceParties = null;
            this.centerDialogVisible = true;
            this.$nextTick(() => this.loadSettlementInvoiceParties());
        },
        payRvDetailDiogClose(){
            this.centerDialogVisible = false;
            this.settlementInvoiceFileList = [];
            this.settlementInvoiceNo = "";
            this.settlementInvoiceIsVat = 1;
            this.settlementInvoiceParties = null;
        },
        loadSettlementInvoiceParties() {
            this.settlementInvoicePartiesLoading = true;
            this.settlementInvoiceParties = null;
            this.$axios
                .settlementInvoiceParties(qs.stringify({}))
                .then((res) => {
                    this.settlementInvoiceParties = res || null;
                    this.settlementInvoicePartiesLoading = false;
                })
                .catch(() => {
                    this.settlementInvoicePartiesLoading = false;
                });
        },
        handleSettlementInvoiceChange(file, fileList) {
            if (!this.settlementNeedsInvoiceFile) {
                this.settlementInvoiceFileList = [];
                return;
            }
            const raw = file.raw;
            if (!raw) {
                this.settlementInvoiceFileList = fileList;
                return;
            }
            const max = 2 * 1024 * 1024;
            const name = raw.name || "";
            if (!/\.(pdf|jpe?g|png)$/i.test(name)) {
                Message.error("仅支持 PDF、JPG、PNG");
                this.$nextTick(() => {
                    const i = fileList.indexOf(file);
                    if (i > -1) fileList.splice(i, 1);
                    this.settlementInvoiceFileList = fileList.slice();
                });
                return;
            }
            if (raw.size > max) {
                Message.error("单文件不超过 2MB");
                this.$nextTick(() => {
                    const i = fileList.indexOf(file);
                    if (i > -1) fileList.splice(i, 1);
                    this.settlementInvoiceFileList = fileList.slice();
                });
                return;
            }
            this.settlementInvoiceFileList = fileList;
        },
        removeSettlementInvoiceFile(file) {
            const uid = file.uid;
            this.settlementInvoiceFileList = this.settlementInvoiceFileList.filter(
                (f) => f.uid !== uid
            );
        },
        handleSettlementInvoicePreview(file) {
            if (file.url) {
                window.open(file.url, "_blank");
                return;
            }
            const raw = file.raw;
            if (!raw) {
                Message.warning("无法预览该文件");
                return;
            }
            const url = URL.createObjectURL(raw);
            const win = window.open(url, "_blank");
            if (!win) {
                URL.revokeObjectURL(url);
                Message.warning("请允许浏览器弹出窗口以便预览");
                return;
            }
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 120000);
        },
        settlementInvoiceHttpRequest() {
            /* 占位：文件仅本地暂存，提交时随 FormData 一次性上传 */
        },
        //发起结算
        payRvDetailList() {
            Loading.service(options);
            let data = {
                leaveDT: this.dayaddTime[0] ,
                leaveToDT: this.dayaddTime[1],
            };

            this.$axios.payRvDetailList(qs.stringify(data)).then((res) => {
                Loading.service(options).close();
                this.applyDialogPage = 1;
                if (res.dataList.length) {
                    this.mTableData = res.dataList;
                } else {
                    this.mTableData = [];
                }
            })
            .catch((err) => {
                Loading.service(options).close();
            });
        },
        //请款申请
        someDingAddPayRvment(){
            if (!this.mTableData.length) {
                Message.error("请款申请不能为空");
                return;
            }
            if (this.settlementNeedsInvoiceFile) {
                if (!this.settlementInvoiceNo || !String(this.settlementInvoiceNo).trim()) {
                    Message.error("请填写发票编号");
                    return;
                }
                const allowedVat = [1, 2, 3, 4];
                if (allowedVat.indexOf(this.settlementInvoiceIsVat) === -1) {
                    Message.error("请选择发票类型");
                    return;
                }
                if (this.settlementInvoiceFileList.length !== 1) {
                    Message.error("请上传 1 张发票");
                    return;
                }
                const inv = this.settlementInvoiceFileList[0];
                if (!inv || !inv.raw) {
                    Message.error("请上传 1 张发票");
                    return;
                }
            }
            let refArr = [];
            this.mTableData.map((val) => {
                refArr.push(
                    {
                        refNumber:val.refNumber,
                        refType:val.refType,
                        actMoney:val.balanceMoney
                    }
                );
            });
            Loading.service(options);
            const fd = new FormData();
            fd.append("refArr", JSON.stringify(refArr));
            fd.append("remark", "");
            fd.append(
                "invoice_no",
                this.settlementNeedsInvoiceFile
                    ? String(this.settlementInvoiceNo).trim()
                    : ""
            );
            fd.append(
                "invoice_is_vat",
                String(
                    this.settlementNeedsInvoiceFile
                        ? this.settlementInvoiceIsVat
                        : 1
                )
            );
            if (this.settlementNeedsInvoiceFile) {
                const f = this.settlementInvoiceFileList[0];
                if (f && f.raw) {
                    fd.append("invoice", f.raw);
                }
            }
            this.$axios.someDingAddPayRvmentMultipart(fd).then((res) => {
                Loading.service(options).close();
                if (res) {
                    Message.success("提交成功");
                    this.mTableData = [];
                    this.payRvDetailDiogClose();
                    this.changeStatus();
                }
            })
            .catch(() => {
                Loading.service(options).close();
            });

        }
    },
};
</script>

<style scoped>
.hundred {
    width: 120px;
}
.hundreded {
    width: 150px;
}

.left-w {
    display: inline-block;
    width: 100px;
}
.fz-4 {
    font-size: 16px;
}

.fc-wan{
    color: #E6A23C;
}

.el-date-editor /deep/ .el-range-separator {
    width: 6%;
}

.card>div{
    width: 50%;
}
.border-l{
    border-left: 1px solid #e7dfe1;
}
.border-r{
    border-right: 1px solid #dfe5e7;
}
.border-t{
    border-top: 1px solid #dfe5e7;
}
.border-b{
    border-bottom: 1px solid #dfe5e7;
}
.p-one{
    padding: 5px;
}
/* 结算列表：筛选条 */
.pay-rv-list-toolbar {
    align-items: center;
    padding: 12px 14px;
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    row-gap: 10px;
    column-gap: 4px;
}

/* 结算明细弹窗：大屏宽 + 表格区域内滚动，避免整页过长 */
.pay-rv-detail-dialog /deep/ .el-dialog__header {
    padding: 14px 20px;
    border-bottom: 1px solid #ebeef5;
}
.pay-rv-detail-dialog /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}
.pay-rv-detail-dialog /deep/ .el-dialog__body {
    padding: 14px 20px 18px;
    background: #f5f7fa;
}
.pay-rv-detail-dialog /deep/ .el-dialog__footer {
    padding: 12px 20px;
    border-top: 1px solid #ebeef5;
    background: #fff;
}
.pay-rv-apply-body {
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    padding: 14px 16px;
}
.pay-rv-section-label {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
    padding-left: 10px;
    border-left: 3px solid #409eff;
    line-height: 1.3;
}
.pay-rv-invoice-parties {
    padding: 12px 14px !important;
    margin-bottom: 14px !important;
    background: linear-gradient(180deg, #fafbfd 0%, #fff 48%);
    border: 1px solid #e4e7ed;
    border-radius: 8px;
}
.pay-rv-invoice-parties .pay-rv-section-label {
    margin-top: 0;
}
.pay-rv-party-grid /deep/ .el-descriptions {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    overflow: hidden;
}
.pay-rv-party-grid /deep/ .el-descriptions__header {
    margin-bottom: 10px;
}
.pay-rv-party-grid /deep/ .el-descriptions__title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
}
.pay-rv-dialog-toolbar {
    row-gap: 8px;
    padding: 12px 14px;
    background: #f9fafb;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    margin-bottom: 4px;
}
.pay-rv-dialog-pager {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    row-gap: 6px;
}
.pay-rv-detail-table {
    border-radius: 6px;
    overflow: hidden;
}
.pay-rv-detail-table /deep/ .el-table__header-wrapper th {
    background: #f0f2f5;
    color: #606266;
    font-weight: 600;
}
.pay-rv-detail-table /deep/ .el-table__footer-wrapper td {
    background: #fafafa;
    font-weight: 600;
}
.pay-rv-invoice-foot {
    margin-top: 16px !important;
    padding: 14px 16px;
    background: #fafbfd;
    border: 1px dashed #c0c4cc;
    border-radius: 8px;
}
.pay-rv-invoice-foot__title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
}
.pay-rv-money-line {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px 12px;
    margin-bottom: 12px !important;
    padding: 10px 12px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #ebeef5;
}
.pay-rv-money-label {
    color: #909399;
    font-size: 12px;
}
.pay-rv-money-value {
    font-size: 18px;
    font-weight: 700;
    color: #e6a23c;
    letter-spacing: 0.02em;
}
.pay-rv-money-hint {
    flex: 1 1 100%;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
}
.pay-rv-dialog-footer {
    text-align: right;
}

.pay-rv-invoice-type-row .pay-rv-invoice-type-select {
    width: 100%;
    max-width: 360px;
}
.pay-rv-detail-dialog .pay-rv-invoice-type-select {
    width: 100%;
    max-width: 360px;
}

.settlement-upload-file-row {
    display: flex;
    align-items: center;
    margin-top: 6px;
    padding: 4px 0;
    line-height: 1.4;
    border-bottom: 1px solid #ebeef5;
}
.settlement-upload-file-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}
.settlement-upload-view-icon {
    font-size: 16px;
    margin-right: 8px;
    margin-left: 0;
    flex-shrink: 0;
    padding: 2px;
}
.settlement-upload-remove-icon {
    font-size: 14px;
    margin-left: 8px;
    flex-shrink: 0;
    color: #606266;
    cursor: pointer;
}
.settlement-upload-remove-icon:hover {
    color: #409eff;
}
.pay-rv-party-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
}
.pay-rv-party-grid .el-descriptions {
    flex: 1 1 320px;
    min-width: 280px;
}
.pay-rv-required-star {
    color: #f56c6c;
    margin-right: 4px;
    font-weight: bold;
}

/* —— 移动端：折叠筛选 + 卡片列表 —— */
.pay-rv-page {
    text-align: left;
}
.pay-rv-mobile-filters {
    margin-bottom: 12px;
}
.pay-rv-mobile-filters /deep/ .el-collapse {
    border: none;
}
.pay-rv-mobile-filters /deep/ .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    font-size: 14px;
    background: #fff;
    border-radius: 8px 8px 0 0;
    border: 1px solid #ebeef5;
    border-bottom: none;
}
.pay-rv-mobile-filters /deep/ .el-collapse-item__wrap {
    border-bottom: none;
}
.pay-rv-mobile-filters /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
    padding-top: 4px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-top: none;
    border-radius: 0 0 8px 8px;
}
.pay-rv-m-fields {
    padding: 0 12px 8px;
}
.pay-rv-m-field {
    margin-bottom: 12px;
}
.pay-rv-m-field:last-child {
    margin-bottom: 4px;
}
.pay-rv-m-label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}
.pay-rv-m-control {
    width: 100% !important;
}
.pay-rv-m-daterange.el-range-editor.el-input__inner {
    width: 100% !important;
    box-sizing: border-box;
}
.pay-rv-m-actions {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 8px;
    margin-top: 10px;
    padding: 0 2px;
}
.pay-rv-m-actions .el-button {
    flex: 1;
    margin-left: 0 !important;
    padding-left: 8px;
    padding-right: 8px;
}
.pay-rv-card-list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.pay-rv-card {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.pay-rv-card:active {
    background: #fafafa;
}
.pay-rv-card__head {
    margin-bottom: 4px;
}
.pay-rv-card__ref {
    font-weight: 600;
    font-size: 13px;
    color: #303133;
    word-break: break-all;
    padding-right: 8px;
    flex: 1;
    min-width: 0;
    line-height: 1.3;
}
.pay-rv-card__badge {
    flex-shrink: 0;
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 4px;
    font-weight: 500;
    line-height: 1.4;
}
.pay-rv-card__badge--ok {
    background: #f0f9eb;
    color: #67c23a;
}
.pay-rv-card__badge--warn {
    background: #fdf6ec;
    color: #e6a23c;
}
.pay-rv-card__badge--danger {
    background: #fef0f0;
    color: #f56c6c;
}
.pay-rv-card__badge--info {
    background: #f4f4f5;
    color: #909399;
}
.pay-rv-card__row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    line-height: 1.35;
    margin-bottom: 3px;
}
.pay-rv-card__row--split {
    margin-bottom: 0;
}
.pay-rv-card__k {
    color: #909399;
    flex-shrink: 0;
    margin-right: 4px;
}
.pay-rv-card__v {
    color: #606266;
    text-align: right;
    word-break: break-word;
    flex: 1;
    min-width: 0;
}
.pay-rv-card__inline {
    flex: 1;
    min-width: 0;
    color: #303133;
    word-break: break-word;
}
.pay-rv-card__inline--r {
    flex: 0 1 auto;
    text-align: right;
    white-space: nowrap;
}
.pay-rv-card__money {
    font-weight: 700;
    color: #303133;
}
.pay-rv-card__link {
    color: #409eff;
    margin-left: 6px;
}
.pay-rv-card__link:first-of-type {
    margin-left: 4px;
}
.pay-rv-card__reject {
    font-size: 11px;
    color: #e6a23c;
    background: #fdf6ec;
    padding: 4px 6px;
    border-radius: 4px;
    margin: 4px 0 0;
    line-height: 1.4;
}
.pay-rv-card__foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #f2f3f5;
    font-size: 12px;
    line-height: 1.3;
}
.pay-rv-card__foot-invoice {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px 4px;
}
.pay-rv-card__foot-link {
    flex-shrink: 0;
    color: #409eff;
    font-weight: 500;
}
.pay-rv-card-empty {
    text-align: center;
    color: #909399;
    font-size: 14px;
    padding: 36px 16px;
    background: #fff;
    border-radius: 10px;
    border: 1px dashed #dcdfe6;
}
.pay-rv-ss-wrap {
    text-align: left;
}
.pay-rv-ss-section {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin: 12px 0 8px;
}
.pay-rv-ss-section:first-child {
    margin-top: 0;
}
.pay-rv-ss-hint {
    margin: 0 0 8px;
    font-size: 12px;
    color: #909399;
    line-height: 1.55;
    word-break: break-word;
}
.pay-rv-ss-kv {
    background: #fafafa;
    border-radius: 8px;
    padding: 4px 12px;
    border: 1px solid #ebeef5;
}
.pay-rv-ss-line {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 0;
    border-bottom: 1px solid #ebeef5;
}
.pay-rv-ss-line:last-child {
    border-bottom: none;
    padding-bottom: 6px;
}
.pay-rv-ss-line:first-child {
    padding-top: 8px;
}
.pay-rv-ss-line-k {
    font-size: 12px;
    color: #909399;
}
.pay-rv-ss-line-v {
    font-size: 14px;
    color: #303133;
    word-break: break-word;
    line-height: 1.45;
}
.pay-rv-ss-line-v--ok {
    color: #67c23a;
    font-weight: 600;
}
.pay-rv-ss-line-v--muted {
    color: #606266;
}
.pay-rv-ss-val--ok {
    color: #67c23a;
    font-weight: 600;
}
.pay-rv-ss-val--muted {
    color: #606266;
}
.pay-rv-ss-alert {
    margin-top: 12px !important;
}
.pay-rv-m-actions .el-button {
    min-height: 40px;
}
.pay-rv-pagination /deep/ .el-pagination {
    justify-content: center;
    flex-wrap: wrap;
}
.pay-rv-party-alert /deep/ .el-alert__title,
.pay-rv-party-alert /deep/ .el-alert__description {
    word-break: break-word;
    white-space: normal;
    line-height: 1.5;
}
.pay-rv-apply-party-m {
    margin-bottom: 8px;
}
.pay-rv-apply-filter-m {
    margin-bottom: 10px;
}
.pay-rv-apply-filter-m__lbl {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
}
.pay-rv-apply-daterange-m.el-range-editor.el-input__inner {
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
}
.pay-rv-apply-daterange-m /deep/ .el-range-input {
    font-size: 12px;
}
.pay-rv-apply-query-m {
    width: 100%;
    margin-top: 12px !important;
    margin-left: 0 !important;
    min-height: 44px;
    font-size: 15px;
}
.pay-rv-apply-hint {
    font-size: 12px;
    line-height: 1.5;
    margin: 10px 0 4px;
}
.pay-rv-apply-lines-m {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.pay-rv-apply-line-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 8px 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.pay-rv-apply-line-card__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}
.pay-rv-apply-line-card__type {
    font-weight: 600;
    font-size: 13px;
    color: #303133;
    flex: 1;
    min-width: 0;
    line-height: 1.3;
}
.pay-rv-apply-line-card__date {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
}
.pay-rv-apply-line-card__row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    font-size: 12px;
    line-height: 1.35;
    margin-bottom: 2px;
}
.pay-rv-apply-line-card__row .k {
    color: #909399;
    flex-shrink: 0;
    margin-right: 4px;
}
.pay-rv-apply-line-card__row .v {
    color: #606266;
    text-align: right;
    word-break: break-all;
    flex: 1;
    min-width: 0;
}
.pay-rv-apply-line-card__money {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #f2f3f5;
    font-size: 12px;
}
.pay-rv-apply-line-card__money-i {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    text-align: center;
}
.pay-rv-apply-line-card__money .mk {
    color: #909399;
    font-size: 11px;
    line-height: 1.2;
}
.pay-rv-apply-line-card__money .mv {
    font-weight: 600;
    color: #303133;
    line-height: 1.25;
    word-break: break-all;
}
.pay-rv-apply-line-card__money-bal {
    color: #f56c6c;
}
.pay-rv-apply-total-bar {
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 8px;
    padding: 8px 10px;
    margin-top: 4px;
}
.pay-rv-apply-total-bar__t {
    font-size: 12px;
    font-weight: 600;
    color: #409eff;
    margin-bottom: 4px;
}
.pay-rv-apply-total-bar__g {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4px 8px;
    font-size: 12px;
    color: #606266;
}
.pay-rv-apply-lines-empty {
    text-align: center;
    padding: 24px 12px;
    font-size: 13px;
}
.pay-rv-invoice-foot--m .pay-rv-money-hint {
    display: block;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.55;
    color: #606266;
}
.pay-rv-invoice-foot--m .pay-rv-money-value {
    font-size: 20px;
}
.pay-rv-upload-hint {
    font-size: 13px;
    line-height: 1.55;
    color: #606266;
}
.pay-rv-upload-pick {
    width: 100%;
    margin-top: 8px !important;
    min-height: 42px;
}
</style>

<style>
/* 结算设置弹窗挂载到 body，需非 scoped；仅 pay-rv-ss--mobile 生效 */
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-dialog__header {
    padding: 14px 52px 10px 16px;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-dialog__headerbtn {
    top: 8px;
    right: 8px;
    padding: 10px;
    font-size: 20px;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-dialog__body {
    padding: 6px 16px 12px;
    max-height: min(70vh, 560px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-dialog__footer {
    padding: 0 !important;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .pay-rv-ss-ft {
    display: block;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .pay-rv-ss-close {
    width: 100%;
    margin: 0 !important;
    min-height: 44px;
    font-size: 15px;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .pay-rv-ss-alert .el-alert__title {
    word-break: break-word;
    white-space: normal;
    line-height: 1.45;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .pay-rv-ss-alert .el-alert__description {
    word-break: break-word;
    white-space: normal;
    line-height: 1.55;
    padding-right: 0;
}
.pay-rv-settlement-setting-dialog.pay-rv-ss--mobile .el-alert__content {
    padding-right: 4px;
}

/* 结算申请 / 详情：custom-class 在 .el-dialog 根节点上 */
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile {
    margin-top: 4vh !important;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile .el-dialog__header {
    padding: 12px 48px 8px 14px;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile .el-dialog__headerbtn {
    top: 6px;
    right: 4px;
    padding: 10px;
    font-size: 20px;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile .el-dialog__body {
    padding: 8px 12px 12px;
    max-height: 78vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile .el-dialog__footer {
    padding: 10px 12px calc(12px + env(safe-area-inset-bottom, 0px)) !important;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile
    .pay-rv-dialog-footer--m {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
}
.el-dialog.pay-rv-detail-dialog.pay-rv-detail-dialog--mobile
    .pay-rv-dialog-footer--m
    .el-button {
    width: 100%;
    margin: 0 !important;
    min-height: 44px;
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/payRvDetailList.vue